import React, { memo } from "react";
import { Line } from "react-chartjs-2";
import { LoadTable } from "../../Components";

const ChartAndTable = ({ chartData, options, data, error, tableKey, colAddition }) => {
  return (
    <div className="charts">
      <div className="load_Post_Chart">
        {Object.keys(chartData).length > 0 ? <Line data={chartData} options={options} /> : null}
      </div>
      <div className="table-container-for-dashboard">
        {data?.length > 0 && (
          <LoadTable
            data={data}
            // loading={isLoading}
            error={error}
            title={tableKey}
            settings={false}
            options={false}
            select={false}
            colAddition={colAddition}
          />
        )}
      </div>
    </div>
  );
};

export default memo(ChartAndTable);
